import { render } from "./CardHome.vue?vue&type=template&id=4deb9acc"
import script from "./CardHome.vue?vue&type=script&lang=js"
export * from "./CardHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__